import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <InfoSection title="Persónuverndarstefna">
            <p>
                Pers&oacute;nuvernd &thorn;&iacute;n skiptir 1819 miklu m&aacute;li. Stefna
                &thorn;essi tekur til pers&oacute;nuuppl&yacute;singa hvort sem &thorn;eim er
                safna&eth; og &thorn;&aelig;r var&eth;veittar me&eth; rafr&aelig;num h&aelig;tti,
                &aacute; papp&iacute;r e&eth;a me&eth; &ouml;&eth;rum samb&aelig;rilegum
                h&aelig;tti. Stefnan tekur til skr&aacute;ningar, v&ouml;rslu og vinnslu &aacute;
                pers&oacute;nuuppl&yacute;singum sem falla undir stefnuna. Stefnan er a&eth;gengileg
                &aacute; heimas&iacute;&eth;u 1819.
            </p>
            <p>
                <strong>PERS&Oacute;NUVERNDARL&Ouml;GGJ&Ouml;F</strong>
            </p>
            <p>
                Um me&eth;fer&eth; pers&oacute;nuuppl&yacute;singa gilda l&ouml;g nr. 90/2018 um
                pers&oacute;nuvernd og vinnslu pers&oacute;nuuppl&yacute;singa eins og &thorn;au eru
                &aacute; hverjum t&iacute;ma, sem og vi&eth;komandi hlutar regluger&eth;ar
                Evr&oacute;pu&thorn;ingsins og r&aacute;&eth;sins (ESB) 2016/679 um vernd
                einstaklinga &iacute; tengslum vi&eth; vinnslu pers&oacute;nuppl&yacute;singa og um
                frj&aacute;lsa mi&eth;lun sl&iacute;kra uppl&yacute;singa. Taka l&ouml;gin m.a.
                &aacute; vinnslu, v&ouml;rslu og mi&eth;lun pers&oacute;nuuppl&yacute;singa.
            </p>
            <p>
                <strong>&Aacute;BYRG&ETH; OG TENGILI&ETH;UR</strong>
            </p>
            <p>
                1819 ber almennt &aacute;byrg&eth; &aacute; skr&aacute;ningu
                pers&oacute;nuuppl&yacute;singa og me&eth;fer&eth; &thorn;eirra uppl&yacute;singa
                &iacute; starfsemi sinni og er svokalla&eth;ur &aacute;byrg&eth;ara&eth;ili vinnslu
                &iacute; skilningi pers&oacute;nuverndarl&ouml;ggjafar vegna &thorn;j&oacute;nustu
                1819, en kann &thorn;&oacute; &iacute; einhverjum tilvikum a&eth; vera
                vinnslua&eth;ili uppl&yacute;singanna e&eth;a eftir atvikum sameiginlegur
                &aacute;byrg&eth;ara&eth;ili me&eth; &ouml;&eth;rum.
            </p>
            <p>
                &THORN;&aacute; eru &thorn;eir a&eth;ilar sem 1819 kann a&eth; mi&eth;la
                uppl&yacute;singum til, sbr. V. kafli &thorn;essarar pers&oacute;nuverndarstefnu,
                sj&aacute;lfst&aelig;&eth;ir &aacute;byrg&eth;ara&eth;ilar var&eth;andi
                &thorn;&aacute; vinnslu uppl&yacute;singa sem fer fram &aacute; &thorn;eirra vegum,
                svo sem &iacute; tengslum vi&eth; marka&eth;sstarfsemi, og bera
                sj&aacute;lfst&aelig;&eth;a &aacute;byrg&eth; &aacute; &thorn;v&iacute; a&eth;
                &ouml;ll me&eth;fer&eth; &thorn;eirra s&eacute; &iacute; samr&aelig;mi vi&eth;
                pers&oacute;nuverndarl&ouml;ggj&ouml;f.
            </p>
            <p>
                H&aelig;gt er a&eth; hafa samband vi&eth; okkur a&eth; Akralind 6, 201
                K&oacute;pavogi, me&eth; &thorn;v&iacute; a&eth; senda skriflega fyrirspurn &aacute;
                1819@1819.is og me&eth; &thorn;v&iacute; a&eth; hringja &iacute; 546-1819 ef
                &thorn;&uacute; hefur einhverjar spurningar &iacute; tengslum vi&eth;
                pers&oacute;nuvernd.
            </p>
            <p>
                <strong>S&Ouml;FNUN OG NOTKUN</strong>
            </p>
            <p>
                Hlutverk okkar er a&eth; mi&eth;la uppl&yacute;singum um einstaklinga,
                fyrirt&aelig;ki og &thorn;j&oacute;nustua&eth;ila sem hafa &oacute;ska&eth; eftir
                &thorn;v&iacute; og sam&thorn;ykkt a&eth; vera skr&aacute;&eth; &iacute;
                s&iacute;maskr&aacute;. Skr&aacute;ning &thorn;&iacute;n er eing&ouml;ngu birt
                me&eth; &thorn;eim h&aelig;tti sem &thorn;&uacute; hefur sam&thorn;ykkt. Vinnsla
                1819 fer &yacute;mist fram vegna framkv&aelig;mdar samnings, sam&thorn;ykkis,
                fyrirm&aelig;la &iacute; l&ouml;gum, reglum og stj&oacute;rnvaldsfyrirm&aelig;lum,
                e&eth;a &aacute; grundvelli l&ouml;gm&aelig;tra hagsmuna. Til a&eth; geta sinnt
                hlutverki okkar s&ouml;fnum vi&eth; eftirfarandi uppl&yacute;singum og vinnum
                me&eth; &thorn;&aelig;r &iacute; eftirfarandi tilgangi:
            </p>
            <p>
                - nafn &thorn;itt, s&iacute;man&uacute;mer og netfang, &aacute;samt IP t&ouml;lu til
                a&eth; geta loki&eth; vi&eth; og uppfyllt &oacute;skir &thorn;&iacute;nar um
                skr&aacute;ningu e&eth;a kaup &aacute; skr&aacute;ningalei&eth;um og annarri
                &thorn;j&oacute;nustu sem vi&eth; bj&oacute;&eth;um upp &aacute; e&eth;a h&ouml;fum
                millig&ouml;ngu um,
            </p>
            <p>
                - nafn &thorn;itt, s&iacute;man&uacute;mer og netfang til a&eth; geta svara&eth;
                fyrirspurnum og brug&eth;ist vi&eth; &oacute;skum &thorn;&iacute;num, t.d. til
                a&eth; svara spurningum &thorn;&iacute;num, &aacute;bendingum og athugasemdum,
            </p>
            <p>
                - nafn &thorn;itt, kennit&ouml;lu, tegund, umfang og dagsetningu vi&eth;skipta til
                a&eth; geta uppfyllt skyldu okkar samkv&aelig;mt b&oacute;khaldsl&ouml;gum,
            </p>
            <p>
                - nafn &thorn;itt, kyn, s&iacute;man&uacute;mer, netfang, f&aelig;&eth;ingardag og
                aldur me&eth; &thorn;&iacute;nu sam&thorn;ykki til a&eth; geta s&yacute;nt
                &thorn;&eacute;r kynningarefni, tilbo&eth; e&eth;a s&eacute;rsni&eth;nar
                augl&yacute;singar &iacute; mi&eth;lum okkar,
            </p>
            <p>
                - nafn &thorn;itt, kyn, s&iacute;man&uacute;mer og netfang me&eth; &thorn;&iacute;nu
                sam&thorn;ykki til a&eth; geta veitt &thorn;&eacute;r kost &aacute; a&eth; taka
                &thorn;&aacute;tt &iacute; k&ouml;nnunum, kynningarherfer&eth;um me&eth;
                ver&eth;launum, keppnum og &ouml;&eth;rum kynningum,
            </p>
            <p>
                - nafn &thorn;itt, kyn, s&iacute;man&uacute;mer og netfang me&eth; &thorn;&iacute;nu
                sam&thorn;ykki til a&eth; geta haft samband vi&eth; &thorn;ig til a&eth; sinna
                g&aelig;&eth;aeftirliti og/e&eth;a ef vi&eth; h&ouml;fum ekki heyrt &iacute;
                &thorn;&eacute;r lengi,
            </p>
            <p>
                - nafn &thorn;itt, IP t&ouml;lu og netfang me&eth; &thorn;&iacute;nu sam&thorn;ykki
                til a&eth; geta gert &thorn;&eacute;r kleift a&eth; nota vef- og
                samf&eacute;lagsmi&eth;las&iacute;&eth;ur okkar,
            </p>
            <p>
                - nafn &thorn;itt, IP t&ouml;lu, netfang og &thorn;&aacute; &oacute;skalista sem
                &thorn;&uacute; b&yacute;r&eth; til &iacute; v&ouml;ruleit 1819, me&eth;
                &thorn;&iacute;nu sam&thorn;ykkki, til a&eth; hj&aacute;lpa &thorn;&eacute;r a&eth;
                halda utan um &oacute;skalista &thorn;&iacute;na og til a&eth; geta sent
                &thorn;&eacute;r uppl&yacute;singar um ver&eth;breytingar &aacute; v&ouml;rum
            </p>
            <p>
                &THORN;&uacute; getur sko&eth;a&eth; og nota&eth; vefsv&aelig;&eth;i og app 1819, og
                vi&eth; s&ouml;fnum uppl&yacute;singum sem vafri &thorn;inn e&eth;a s&iacute;mi
                veitir og eru mikilv&aelig;g til a&eth; n&yacute;ta &thorn;j&oacute;nustu okkar sem
                best, &thorn;.e. g&ouml;gn sem geta fali&eth; &iacute; s&eacute;r uppl&yacute;singar
                eins og s&iacute;man&uacute;mer, IP-t&ouml;lu, tegund vafra, &uacute;tg&aacute;fu
                vafra, s&iacute;&eth;ur &thorn;j&oacute;nustunnar, t&iacute;ma og dagsetningu
                heims&oacute;knar og &ouml;nnur talnag&ouml;gn.
            </p>
            <p>
                Vi&eth; notum vefk&ouml;kur til &thorn;ess a&eth; a&eth;greina &thorn;ig fr&aacute;
                &ouml;&eth;rum notendum &aacute; vefs&iacute;&eth;u 1819. Vefk&ouml;kur eru litlar
                textaskr&aacute;r sem netvafrinn &thorn;inn vistar &aacute; t&ouml;lvunni
                &thorn;inni s&eacute; netvafrinn &thorn;inn stilltur til a&eth; sam&thorn;ykkja
                notkun &aacute; vefk&ouml;kum. Vefk&ouml;kurnar gera okkur kleift a&eth; muna
                &aacute;kve&eth;nar stillingar hj&aacute; notanda til a&eth; b&aelig;ta
                notendaupplifun og f&aacute; t&ouml;lfr&aelig;&eth;iuppl&yacute;singar um notkun
                &aacute; vefs&iacute;&eth;u 1819.is.
            </p>
            <p>
                Notendur geta &aacute;kve&eth;i&eth; hvort &thorn;eir leyfa sumar e&eth;a allar
                vefk&ouml;kur me&eth; stillingum &iacute; netvafra. Ef notendur kj&oacute;sa a&eth;
                leyfa ekki vefk&ouml;kur &thorn;&aacute; kann hluti vefs&iacute;&eth;unnar a&eth;
                ver&eth;a &oacute;a&eth;gengilegur.
            </p>
            <p>
                Er framangreindra uppl&yacute;singa &yacute;mist afla&eth; beint fr&aacute;
                vi&eth;komandi einstaklingi e&eth;a &thorn;eim mi&eth;la&eth; fr&aacute;
                vi&eth;komandi fjarskiptafyrirt&aelig;ki &thorn;ar sem einstaklingur skr&aacute;ir
                sig &iacute; s&iacute;maskr&aacute;, um er a&eth; r&aelig;&eth;a uppl&yacute;singar
                um veitta &thorn;j&oacute;nustu e&eth;a sj&aacute;lfvirka
                uppl&yacute;singas&ouml;fnun vegna notkunar &aacute; vefsv&aelig;&eth;i og appi
                1819.
            </p>
            <p>
                1819 notar &thorn;j&oacute;nustur Google Analytics og Facebook Pixel til a&eth;
                greina umfer&eth; um mi&eth;la 1819 og birta notendum s&eacute;rsni&eth;nar
                augl&yacute;singar. &THORN;essar &thorn;j&oacute;nustur safna uppl&yacute;singum
                nafnlaust og gefa sk&yacute;rslur um &thorn;r&oacute;un &aacute;
                vefsv&aelig;&eth;um, &aacute;n &thorn;ess a&eth; greint s&eacute; fr&aacute;
                st&ouml;kum notendum e&eth;a pers&oacute;nuuppl&yacute;singum.
            </p>
            <p>
                <strong>MI&ETH;LUN</strong>
            </p>
            <p>
                Hlutverk okkar er a&eth; mi&eth;la uppl&yacute;singum um einstaklinga,
                fyrirt&aelig;ki og &thorn;j&oacute;nustua&eth;ila sem hafa &oacute;ska&eth; eftir
                &thorn;v&iacute; og sam&thorn;ykkt a&eth; vera skr&aacute;&eth; &iacute;
                s&iacute;maskr&aacute;. Vi&eth; bj&oacute;&eth;um fj&ouml;lbreyttar
                &thorn;j&oacute;nustulei&eth;ir til &thorn;ess a&eth; n&aacute;lgast &thorn;&aelig;r
                uppl&yacute;singar sem vi&eth; mi&eth;lum, t.d.
                &thorn;j&oacute;nustun&uacute;meri&eth; 1819 og 1819.is vefinn/appi&eth;, vi&eth;
                veitum fyrirt&aelig;kjum og &thorn;j&oacute;nustua&eth;ilum jafnframt
                t&aelig;kni&thorn;j&oacute;nustu sem einfaldar &thorn;eim a&eth;gengi a&eth;
                &thorn;eim uppl&yacute;singum sem vi&eth; mi&eth;lum.
            </p>
            <p>
                Ef &thorn;&uacute; ert skr&aacute;&eth;(ur) &iacute; s&iacute;maskr&aacute;
                &thorn;&aacute; mi&eth;lum vi&eth; &thorn;eim pers&oacute;nuuppl&yacute;singum til
                &thorn;ri&eth;ja a&eth;ila sem &thorn;&uacute; hefur sam&thorn;ykkt a&eth;
                s&eacute;u birtar, og eru &thorn;&aacute; &thorn;eir a&eth;ilar sem 1819 kann a&eth;
                mi&eth;la uppl&yacute;singum til, sj&aacute;lfst&aelig;&eth;ir
                &aacute;byrg&eth;ara&eth;ilar var&eth;andi &thorn;&aacute; vinnslu uppl&yacute;singa
                sem fer fram &aacute; &thorn;eirra vegum, svo sem &iacute; tengslum vi&eth;
                marka&eth;sstarfsemi. &Iacute; einhverjum tilvikum kunnum vi&eth; a&eth; mi&eth;la
                einnig pers&oacute;nuuppl&yacute;singum til &thorn;ri&eth;ja a&eth;ila sem okkur er
                skylt samkv&aelig;mt l&ouml;gum e&eth;a &iacute; &thorn;eim tilvikum sem talin eru
                upp undir li&eth; Verndun.
            </p>
            <p>
                <strong>&THORN;RI&ETH;JU A&ETH;ILAR</strong>
            </p>
            <p>
                Okkur er heimilt a&eth; mi&eth;la pers&oacute;nuuppl&yacute;singum til
                &thorn;ri&eth;ja a&eth;ila (vinnslua&eth;ila) sem er &thorn;j&oacute;nustuveitandi,
                umbo&eth;sma&eth;ur e&eth;a verktaki okkar &iacute; &thorn;eim tilgangi a&eth;
                lj&uacute;ka vi&eth; verkefni e&eth;a veita &thorn;&eacute;r &thorn;j&oacute;nustu
                e&eth;a v&ouml;ru sem &thorn;&uacute; hefur be&eth;i&eth; um e&eth;a sam&thorn;ykkt.
                Okkur er einnig heimilt a&eth; deila uppl&yacute;singum me&eth; vinnslua&eth;ilum
                &thorn;egar &thorn;a&eth; er nau&eth;synlegt til a&eth; vernda br&yacute;na hagsmuni
                t.d. vi&eth; innheimtu &aacute; vanskilakr&ouml;fu. Vi&eth; deilum einnig
                uppl&yacute;singum, &iacute; t&ouml;lfr&aelig;&eth;ilegum tilgangi, me&eth;
                vinnslua&eth;ilum sem vinna me&eth; okkur vi&eth; g&aelig;&eth;a og
                marka&eth;sstarf. Vi&eth; afhendum vinnslua&eth;ilunum einungis &thorn;&aelig;r
                pers&oacute;nuuppl&yacute;singar sem eru nau&eth;synlegar fyrir &thorn;&aacute;
                &iacute; framangreindum tilgangi og gerum vi&eth; &thorn;&aacute; samning &thorn;ar
                sem &thorn;eir undirgangast skyldu um a&eth; halda uppl&yacute;singum um &thorn;ig
                &ouml;ruggum og nota &thorn;&aelig;r einungis &iacute; framangreindum tilgangi.
            </p>
            <p>
                &THORN;&aacute; er athygli &thorn;&iacute;n vakin &aacute; a&eth; allt efni sem
                &thorn;&uacute; birtir e&eth;a deilir &aacute;
                samf&eacute;lagsmi&eth;las&iacute;&eth;um okkar eru opinberar uppl&yacute;singar.
                Athygli &thorn;&iacute;n er vakin &aacute; a&eth; me&eth; &thorn;v&iacute; a&eth;
                tengja saman s&iacute;&eth;ureikning &thorn;inn og
                samf&eacute;lagsmi&eth;lareikninginn &thorn;inn gefur &thorn;&uacute; okkur leyfi
                til a&eth; deila uppl&yacute;singum me&eth; veitanda
                samf&eacute;lagsmi&eth;la&thorn;j&oacute;nustunnar og notkun &thorn;eirra
                uppl&yacute;singa sem vi&eth; deilum stj&oacute;rnast af stefnu
                samf&eacute;lagsmi&eth;ilsins um pers&oacute;nuvernd. Ef &thorn;&uacute; vilt ekki
                a&eth; pers&oacute;nuuppl&yacute;singum &thorn;&iacute;num s&eacute; deilt me&eth;
                &ouml;&eth;rum notendum e&eth;a me&eth; veitanda
                samf&eacute;lagsmi&eth;la&thorn;j&oacute;nustunnar, skaltu ekki tengja
                samf&eacute;lagsmi&eth;lareikninginn &thorn;inn vi&eth; s&iacute;&eth;ureikninginn
                e&eth;a deila efni inn &aacute; samf&eacute;lagsmi&eth;la fr&aacute;
                s&iacute;&eth;unni.
            </p>
            <p>
                Pers&oacute;nuverndarstefnan n&aelig;r ekki til uppl&yacute;singa e&eth;a vinnslu
                &thorn;ri&eth;ju a&eth;ila en vi&eth; h&ouml;fum enga stj&oacute;rn &aacute;
                n&eacute; berum &aacute;byrg&eth; &aacute; notkun, birtingu e&eth;a &ouml;&eth;rum
                verkum &thorn;eirra. Vi&eth; hvetjum &thorn;ig &thorn;v&iacute; til a&eth; kynna
                &thorn;&eacute;r pers&oacute;nuverndarstefnu &thorn;ri&eth;ju a&eth;ila, &thorn;.
                &aacute; m. vefh&yacute;singara&eth;ilum &thorn;eirra s&iacute;&eth;na sem geta
                v&iacute;sa&eth; &aacute; okkar, hugb&uacute;na&eth;arfyrirt&aelig;kja &aacute;
                bor&eth; vi&eth; Facebook, Apple, Google og Microsoft &aacute;samt &thorn;eirri
                grei&eth;slu&thorn;j&oacute;nustu sem &thorn;&uacute; k&yacute;st a&eth; nota.
            </p>
            <p>
                <strong>VERNDUN</strong>
            </p>
            <p>
                1819 leggur mikla &aacute;herslu &aacute; a&eth; vernda vel allar
                pers&oacute;nuuppl&yacute;singar og hefur &thorn;v&iacute; yfir a&eth; skipa innra
                eftirlitskerfi sem &aacute; a&eth; tryggja a&eth; &aacute;vallt skulu ger&eth;ar
                vi&eth;eigandi t&aelig;knilegar og skipulagslegar
                &ouml;ryggisr&aacute;&eth;stafanir.
            </p>
            <p>
                Vi&eth; munum tilkynna &thorn;&eacute;r &aacute;n &oacute;tilhl&yacute;&eth;ilegrar
                tafar ef &thorn;a&eth; kemur upp &ouml;ryggisbrot er var&eth;ar
                pers&oacute;nuuppl&yacute;singarnar &thorn;&iacute;nar sem hefur &iacute; f&ouml;r
                me&eth; s&eacute;r mikla &aacute;h&aelig;ttu fyrir &thorn;ig. Me&eth;
                &ouml;ryggisbroti &iacute; framangreindum skilningi er &aacute;tt vi&eth; brot
                &aacute; &ouml;ryggi sem lei&eth;ir til &oacute;viljandi e&eth;a
                &oacute;l&ouml;gm&aelig;trar ey&eth;ingar pers&oacute;nuuppl&yacute;singa e&eth;a
                a&eth; &thorn;&aelig;r glatist, breytist, ver&eth;i birtar e&eth;a a&eth;gangur
                veittur a&eth; &thorn;eim &iacute; leyfisleysi.
            </p>
            <p>
                Athygli &thorn;&iacute;n er &thorn;&oacute; vakin &aacute; &thorn;v&iacute; a&eth;
                &thorn;&uacute; ber&eth; &aacute;byrg&eth; &aacute;
                pers&oacute;nuuppl&yacute;singum, t.d. nafni, kennit&ouml;lu og mynd, sem
                &thorn;&uacute; k&yacute;st a&eth; deila e&eth;a senda &aacute; almennum vettvangi
                t.d. &iacute; gegnum Facebook s&iacute;&eth;u 1819.
            </p>
            <p>
                <strong>VAR&ETH;VEISLA</strong>
            </p>
            <p>
                1819 reynir eftir fremsta megni a&eth; halda pers&oacute;nuuppl&yacute;singum um
                &thorn;ig n&aacute;kv&aelig;mum og &aacute;rei&eth;anlegum og uppf&aelig;rir
                &thorn;&aelig;r eftir &thorn;&ouml;rfum. Vi&eth; var&eth;veitum
                pers&oacute;nuuppl&yacute;singar um &thorn;ig &aacute; me&eth;an &thorn;&uacute;
                vilt vera skr&aacute;&eth;(ur) &iacute; s&iacute;maskr&aacute;. Vi&eth; h&ouml;ldum
                &uacute;ti s&eacute;rstakri &thorn;j&oacute;nustu vi&eth; skr&aacute;ningar
                &thorn;&iacute;nar og metum st&ouml;&eth;ugt hvort okkur s&eacute; heimilt a&eth;
                var&eth;veita &thorn;&aelig;r &aacute;fram. Ef vi&eth; &aacute;kve&eth;um a&eth;
                okkur s&eacute; ekki heimilt a&eth; var&eth;veita &thorn;&aelig;r &aacute;fram,
                munum vi&eth; h&aelig;tta allri vinnslu me&eth; pers&oacute;nuuppl&yacute;singarnar
                fr&aacute; &thorn;eim t&iacute;ma. Ef m&ouml;guleiki er &aacute; a&eth;
                pers&oacute;nuuppl&yacute;singanna kunni a&eth; vera &thorn;&ouml;rf
                s&iacute;&eth;ar til a&eth; uppfylla lagaskyldur, t.d. gagnvart
                skattyfirv&ouml;ldum, e&eth;a til a&eth; h&ouml;f&eth;a e&eth;a verjast
                r&eacute;ttarkr&ouml;fu, munum vi&eth; taka afrit af hluta&eth;eigandi
                pers&oacute;nuuppl&yacute;singum og var&eth;veita &thorn;&aelig;r &aacute;
                &ouml;ruggu formi eins lengi og nau&eth;syn ber til.
            </p>
            <p>
                <strong>R&Eacute;TTINDI &THORN;&Iacute;N</strong>
            </p>
            <p>
                &THORN;&uacute; &aacute;tt r&eacute;tt &aacute; og getur &oacute;ska&eth; eftir
                eftirfarandi uppl&yacute;singum me&eth; &thorn;v&iacute; a&eth; senda skriflega
                fyrirspurn &aacute; 1819@1819.is
            </p>
            <p>
                a&eth; f&aacute; a&eth; vita hva&eth;a pers&oacute;nuuppl&yacute;singar eru
                skr&aacute;&eth;ar um &thorn;ig og hvernig &thorn;&aelig;r eru tilkomnar og
                f&aacute; a&eth;gang a&eth; pers&oacute;nuuppl&yacute;singunum,
            </p>
            <p>
                a&eth; f&aacute; uppl&yacute;singar um hvernig pers&oacute;nuuppl&yacute;singar um
                &thorn;ig s&eacute;u unnar,
            </p>
            <p>
                a&eth; pers&oacute;nuuppl&yacute;singar um &thorn;ig s&eacute;u uppf&aelig;r&eth;ar
                og lei&eth;r&eacute;ttar,
            </p>
            <p>
                a&eth; pers&oacute;nuuppl&yacute;singum um &thorn;ig s&eacute; eytt, ef ekki er
                lengur m&aacute;lefnaleg &aacute;st&aelig;&eth;a til a&eth; var&eth;veita
                &thorn;&aelig;r,
            </p>
            <p>
                a&eth; andm&aelig;la og / e&eth;a takmarka hvernig pers&oacute;nuuppl&yacute;singar
                s&eacute;u unnar,
            </p>
            <p>
                a&eth; f&aacute; afhentar pers&oacute;nuuppl&yacute;singar sem &thorn;&uacute; hefur
                l&aacute;ti&eth; okkur &iacute; t&eacute; e&eth;a a&eth; &thorn;&aelig;r s&eacute;u
                sendar beint til annars a&eth;ila me&eth; &thorn;eim takm&ouml;rkunum sem
                r&eacute;ttindi og frelsi annarra setja,
            </p>
            <p>
                a&eth; afturkalla sam&thorn;ykki &thorn;itt til vinnslu &thorn;egar vinnsla byggist
                &aacute; &thorn;eirri heimild, me&eth; sama h&aelig;tti og &thorn;&uacute; gafst
                &thorn;a&eth; e&eth;a me&eth; &thorn;v&iacute; a&eth; senda &aacute; okkur skriflega
                fyrirspurn,
            </p>
            <p>
                a&eth; f&aacute; uppl&yacute;singar um hvort fram fari sj&aacute;lfvirk
                &aacute;kvar&eth;anataka, &thorn;.m.t. ger&eth; pers&oacute;nusni&eth;s og &thorn;au
                r&ouml;k sem &thorn;ar liggja a&eth; baki og einnig &thorn;&yacute;&eth;ingu og
                fyrirhuga&eth;ar aflei&eth;ingar sl&iacute;krar vinnslu.
            </p>
            <p>
                Bei&eth;ni &thorn;&iacute;n ver&eth;ur tekin til greina og &thorn;&eacute;r afhentar
                uppl&yacute;singarnar (&thorn;egar &thorn;a&eth; &aacute; vi&eth;) innan
                h&aelig;filegs t&iacute;ma, &thorn;&oacute; me&eth; &thorn;eim takm&ouml;rkunum sem
                r&eacute;ttindi og frelsi annarra gera, &thorn;.m.t. vi&eth;skiptaleyndarm&aacute;l
                og hugverkar&eacute;ttindi. Athygli er vakin &aacute; a&eth; innheimt er sanngjarnt
                gjald byggt &aacute; ums&yacute;slukostna&eth;i s&eacute; fari&eth; fram &aacute;
                meira en eitt eintak. &THORN;&eacute;r ver&eth;ur tilkynnt og gefin sk&yacute;ring
                ef t&ouml;f ver&eth;ur &aacute; afgrei&eth;slu e&eth;a ef ekki er unnt a&eth;
                ver&eth;a vi&eth; bei&eth;ninni a&eth; fullu eigi s&iacute;&eth;ar en
                m&aacute;nu&eth;i fr&aacute; m&oacute;tt&ouml;ku hennar.
            </p>
            <p>
                &THORN;&uacute; &aacute;tt &aacute;vallt r&eacute;tt &aacute; &thorn;v&iacute;
                a&eth; kvarta til Pers&oacute;nuverndar komi upp &aacute;greiningur um
                me&eth;fer&eth; pers&oacute;nuppl&yacute;singa, en vi&eth; myndum hins vegar kunna
                a&eth; meta &thorn;a&eth; a&eth; &thorn;&uacute; g&aelig;fir okkur
                t&aelig;kif&aelig;ri fyrst til &thorn;ess a&eth; leysa m&aacute;li&eth;
                &aacute;&eth;ur en &thorn;&uacute; hefur samband vi&eth; Pers&oacute;nuvernd.
            </p>
            <p>
                <strong>PERS&Oacute;NUVERND BARNA</strong>
            </p>
            <p>
                Pers&oacute;nuuppl&yacute;singar um b&ouml;rn yngri en 18 &aacute;ra er ekki
                safna&eth; nema me&eth; sam&thorn;ykki forr&aacute;&eth;amanns.
            </p>
            <p>
                <strong>BREYTINGAR </strong>
            </p>
            <p>
                Pers&oacute;nuverndarstefnan er endursko&eth;u&eth; reglulega og kann
                &thorn;v&iacute; a&eth; taka breytingum. &THORN;&eacute;r er &thorn;v&iacute;
                r&aacute;&eth;lagt a&eth; kynna &thorn;&eacute;r pers&oacute;nuverndarstefnuna
                reglulega en breytingar &aacute; stefnunni &ouml;&eth;last gildi vi&eth; birtingu
                &aacute; heimas&iacute;&eth;u fyrirt&aelig;kisins; www.1819.is. &THORN;egar
                efnislegar breytingar eru ger&eth;ar sem hafa &aacute;hrif &aacute; r&eacute;ttindi
                &thorn;&iacute;n munum vi&eth; tilkynna s&eacute;rstaklega um &thorn;&aelig;r
                me&eth; t&ouml;lvup&oacute;stskilabo&eth;um og/e&eth;a me&eth; SMS skeyti.
            </p>
            <p>Sam&thorn;ykkt &iacute; j&uacute;l&iacute; 2018</p>
            <p>S&iacute;&eth;ast breytt &iacute; j&uacute;n&iacute; 2021</p>
        </InfoSection>
    );
}
export default ServiceNumber;
